import React from "react";
import { Header, Transition, Button } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import { googleTracking } from '../../../util';
import { connect } from 'react-redux';
import {
  resetConnection
} from "../../..//store/actions/connection";

class UnAvailable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      animation: props.animation
    };
    this.transitionBack = this.transitionBack.bind(this);
    this.checkNewAddress = this.checkNewAddress.bind(this);
  }

  componentDidMount() {
    this.setState({
      visible: true
    });
    googleTracking({ 'event': 'virtualPageview', 'pageview': '/unavailable&not-compatible/step2/come-back-soon' });
  }

  transitionBack() {
    const { setServiceAvailable, changeStep, result_type, fromPage } = this.props;

    this.setState({
      animation: "fade left",
      visible: !this.state.visible
    });
    setTimeout(() => {
      if (fromPage === 'request-fibrestream') {
        changeStep(9, "fade right");
      }
      else if (result_type === 5) {
        changeStep(12, "fade right")
      }
      else {
        setServiceAvailable(null, "fade right");
      }
    }, 400);
  }

  checkNewAddress() {
    const { changeStep } = this.props;

    googleTracking({
      'event': 'GAevent',
      'eventCategory': 'check-new-address',
      'eventAction': 'submit',
      'eventLabel': ''
    });
    this.setState({
      animation: "fade right",
      visible: !this.state.visible
    });
    setTimeout(() => {
      this.props.resetConnection();
      changeStep(9, "fade left");
    }, 400);
  }

  render() {
    const { visible, animation } = this.state;

    return (
      <div>
        <div className="back--icon" onClick={this.transitionBack} />
        <Transition visible={visible} duration={500} animation={animation}>
          <div>
            <Header className="title__main" as="h1" textAlign="center">
              Come Back Soon
            </Header>
            <Header.Subheader className="text-black">
              Service is not compatible with your building. We are working hard
              to make FibreStream compatible with more buildings. Check back again
              soon.
            </Header.Subheader>

            <Button
              size="medium"
              className="ml-auto mr-auto d-flex"
              onClick={this.checkNewAddress}
            >
              CHECK NEW ADDRESS
            </Button>
          </div>
        </Transition>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    result_type: state.connection.result_type,
    fromPage: state.connection.fromPage
  }
}
const mapDispatchToProps = dispatch => {
  return {
    resetConnection: () => dispatch(resetConnection())
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UnAvailable));



// WEBPACK FOOTER //
// ./src/components/check-availability/service-not-available/UnAvailable.js